import React from 'react';
import { 
  Box, 
  Typography, 
  Card, 
  CardContent, 
  CardActions, 
  Button 
} from '@mui/material';
import { Playlist } from '../../models';

interface TracksAddedProps {
  playlist: Playlist;
  onViewDetails: (playlistId: string) => void;
}

const TracksAdded: React.FC<TracksAddedProps> = ({ playlist, onViewDetails }) => {
  return (
    <Box>
      <Typography variant="h6" gutterBottom>Tracks Added to Playlist</Typography>
      <Card>
        <CardContent>
          <Typography variant="h5">{playlist.name}</Typography>
          <Typography variant="body2" color="text.secondary" paragraph>
            {playlist.description || 'No description'}
          </Typography>
          <Typography variant="body2">
            {playlist.totalTracks} tracks • Updated
          </Typography>
        </CardContent>
        <CardActions>
          <Button 
            size="small" 
            onClick={() => onViewDetails(playlist.id)}
          >
            View Details
          </Button>
        </CardActions>
      </Card>
    </Box>
  );
};

export default TracksAdded;
